module.exports = __webpack_public_path__ + "img/red3.35173da7.png";